import { render, staticRenderFns } from "./SeriesField.vue?vue&type=template&id=2bc63546&scoped=true&"
import script from "./SeriesField.vue?vue&type=script&lang=js&"
export * from "./SeriesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc63546",
  null
  
)

export default component.exports